<script setup lang="ts">
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

defineProps<{
  visible: boolean;
  geofenceName: string;
  loading?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void;
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}>();

function onCancel() {
  emit('cancel');
  emit('update:visible', false);
}

function onConfirm() {
  emit('confirm');
}
</script>

<template>
  <Dialog
    :visible="visible"
    modal
    :closable="false"
    :draggable="false"
    :style="{ width: '420px' }"
    @update:visible="(v) => emit('update:visible', v)"
  >
    <template #header>
      <h3
        class="text-gpx_base font-semibold text-gpx_black-50"
        data-testid="removal-confirm-title"
      >
        Remove {{ geofenceName }}?
      </h3>
    </template>
    <p class="text-gpx_sm text-gpx_black-50">
      This will permanently delete this geofence and all its alert
      configurations. This cannot be undone.
    </p>
    <template #footer>
      <div class="flex justify-end gap-2">
        <Button
          label="Cancel"
          severity="secondary"
          outlined
          size="small"
          :disabled="loading"
          data-testid="removal-confirm-cancel"
          @click="onCancel"
        />
        <Button
          label="Remove"
          severity="danger"
          size="small"
          :loading="loading"
          data-testid="removal-confirm-remove"
          @click="onConfirm"
        />
      </div>
    </template>
  </Dialog>
</template>
